import PropTypes from 'prop-types';
import _ from 'lodash';

const FlagButtons = ({
  value = [],
  onChange = () => {},
  options,
  error = null,
}) => (
  <div style={{ position: 'relative' }}>
    {_.map(options, (option, i) => (
      <div className="flag-button" key={i}>
        <input
          type="checkbox"
          name={`flag-${i}`}
          value={option.value}
          checked={value.includes(option.value)}
          onChange={event => {
            let newValue = [...value];
            if (event.target.checked) {
              newValue.push(option.value);
            } else {
              newValue = newValue.filter(v => v !== option.value);
            }
            onChange(newValue);
          }}
        />
        <div className="flag-box">
          <span className="flag-label">{option.label}</span>
        </div>
      </div>
    ))}
    {error && <p className="onboarding-error">{error}</p>}
  </div>
);

FlagButtons.propTypes = {
  value: PropTypes.array, // comes from RHF Controller
  onChange: PropTypes.func, // comes from RHF Controller
  options: PropTypes.array.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // RHF error message
};

export default FlagButtons;
